import { ComponentCO2 } from '@acies/domain';
import { ObservableCollection } from '@acies/observables';

export default class DeleteComponentCO2Model {
	public deleteButtonEnabled: boolean;
	public deleteSpinnerVisible: boolean;
	public selectAllCheckBoxSelected: boolean;
	public itemsToBeDeleted: ObservableCollection<ComponentCO2>;
	public dialogCancelButtonEnabled: boolean;
	public dialogDeleteButtonEnabled: boolean;
	public networkErrorLabelVisible: boolean;
	public unknownErrorLabelVisible: boolean;
	public constructor() {
		this.deleteButtonEnabled = false;
		this.deleteSpinnerVisible = false;
		this.selectAllCheckBoxSelected = false;
		this.itemsToBeDeleted = new ObservableCollection();
		this.dialogCancelButtonEnabled = true;
		this.dialogDeleteButtonEnabled = true;
		this.networkErrorLabelVisible = false;
		this.unknownErrorLabelVisible = false;
	}
}
